(() => {
  'use strict';

  const cleanTemplate = (value) => (value || '')
    .replace(/\{\{\s*language\s*\}\}/gi, '')
    .replace(/\s+/g, ' ')
    .trim();

  const scan = () => {
    const settings = window.jdgmSettings || {};
    if (settings.widget_translate_review_content_enabled !== true) return;
    if (settings.widget_translate_review_content_method !== 'automatic') return;

    const translateText = cleanTemplate(settings.widget_translate_review_text);
    const originalText = cleanTemplate(settings.widget_show_original_translation_text);
    if (!translateText) return;

    document.querySelectorAll('.jdgm-translate-button').forEach((button) => {
      const text = (button.textContent || '').replace(/\s+/g, ' ').trim();
      if (button.dataset.pp2AutoTranslate === '1') return;
      if (originalText && text.includes(originalText)) return;
      if (!text.includes(translateText)) return;

      button.dataset.pp2AutoTranslate = '1';
      button.click();
    });
  };

  scan();
  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 60000);
})();
